import { api } from 'src/services/api'

export type Infraction = {
  id: string
  status: string
  analysis_status: string
  analysis_date: string
  analysis_description: string
  situation_type: string
  transaction_id: string
  amount: number
  infraction_date: string
  payer_name: string
  payer_tax_id: string
  refund: {
    status: string
    analysis_status: string
    transaction_id: string
    refunded_amount: number
    refund_date: string
    rejection_reason: string
  }
  user: {
    name: string
  }
}

type Response = Infraction
type Request = {
  analysis_description: string
  analysis: 'accepted' | 'rejected'
  files: File[]
}

export async function sendInfractionAnalysis(form: FormData) {
  try {
    const token = localStorage.getItem('@backoffice:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    if (user?.virtual_account_id) {
      form.append('accountId', user.virtual_account_id)

      const response = await api.post<Response>(
        `/graphic/infractions/analysis`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } else {
      const response = await api.post<Response>(
        `/graphic/infractions/analysis/admin`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    }
  } catch (error) {
    console.log(error)
  }
}
